export const environment = {
  production: true,
  BASE_DOMAIN:'https://lms-uat.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://lms-uat.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://lms-uat.apollosupplychain.com/',
  AUTH_URL:'https://auth.apollosupplychain.com/auth-service/',
  WebsocketUrl: 'wss://lms-uat.apollosupplychain.com/websocket-service/ws/notifications'
};